import React, { ReactNode } from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faMultiply } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import CustomMenuClient from "../../Displays/CustomMenuClient";
import CustomToggleClient from "../../Displays/CustomToggleClient";
import DropdownItemCheck from "../Dropdown/DropdownItemCheck";
import DropdownItemUI from "../Dropdown/DropdownItemUI";

interface IProps {
    options: Array<{ option: string; checked: boolean; label?: ReactNode }>;
    onChange: (checked: boolean, option: string) => void;
    name: ReactNode;
    clearAll: () => void;
    noTranslation?: boolean;
    className?: string;
}

const FilterDropdown = (props: IProps) => {
    const { t } = useTranslation();

    const disabled = false;

    return (
        <Dropdown className={`${disabled && "disableDropdownNotAllowed"} ${props.className}`}>
            <Dropdown.Toggle
                as={CustomToggleClient}
                id="dropdown-custom-components"
                className={`custom-dropdown-toggle ${disabled && "disableDropdown"}`}
            >
                {props.name}
                <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu as={CustomMenuClient} className="custom-dropdown-menu">
                {props.options.map((option) => {
                    return (
                        <Dropdown.Item
                            as="li"
                            eventKey="5"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            key={option.option}
                        >
                            <DropdownItemCheck
                                text={option.label || option.option}
                                icon={faMultiply}
                                checked={option.checked}
                                onChange={(checkBool: boolean) => props.onChange(checkBool, option.option)}
                                name={option.option}
                            />
                        </Dropdown.Item>
                    );
                })}
                <Dropdown.Divider />

                <Dropdown.Item
                    as="li"
                    eventKey="5"
                    onClick={(e) => {
                        props.clearAll();
                        e.stopPropagation();
                    }}
                >
                    <DropdownItemUI text={t("CommonUI.shared.ClearFilters")} icon={faMultiply} />
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default FilterDropdown;
